<template>
  <div>
    <div>
      <yxt-switch
        v-model="value.inside"
        :active-value="1"
        :inactive-value="0"
      ></yxt-switch>
      <span class="tlive-create__tip">
        &nbsp;
        {{
          $t(
            'pc_biz_openToEnterprisesAll' /* 对企业公开，所有员工通过链接或从“直播广场”观看 */
          )
        }}
      </span>
    </div>
    <div>
      <yxt-switch
        v-model="value.publishType"
        :active-value="1"
        :inactive-value="0"
      ></yxt-switch>
      <span class="tlive-create__tip">
        &nbsp;
        {{ $t('pc_biz_broadcastLiveSquare' /* 发布到直播广场 */) }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LiveInside',
  props: {
    value: {
      type: Object,
      default: {}
    }
  }
};
</script>
<style scoped lang="less"></style>
